import React, { useContext, useState } from "react";
import { Button } from "react-bulma-components/full";
import FACTURE1 from "../../assets/img/facture1.png";
import FACTURE2 from "../../assets/img/facture2.png";
import FACTURE from "../../assets/img/facture.webp";

import landingPV from "../../assets/img/PV.jpg";
import styled from "styled-components";
import { Square } from "../../assets/style/commonStyledComponent";

export const Step2 = (props) => {
  const StepContainer = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align &.step-5 {
      background: url(${landingPV});
    }
  `;

  const Img = styled.img`
    position: relative;
    margin: auto auto;
    width: 100% !important;
  `;

  return (
    <StepContainer>
      <Square>
        <Img src={FACTURE} />
      </Square>
    </StepContainer>
  );
};
